<template>
    <carousel :gap="{
      base: 16,
      sm: 16,
      md: 32,
      lg: 16,
      xl: 32
    }"
              :title="__(`messages.continue_with_search${site.siteName}`)" v-if="history.length > 0">
        <recent-search v-for="registry in history"
                       :key="registry.id"
                       :hrefe="registry.url"
                       :image="registry.image"
                       :type="registry.title"
                       :icon-class="registry.icon"
                       :destination="registry.name"
                       :dates="formatDate(registry.startDate, registry.endDate, registry.mode)"
                       :guests="registry.paxInfo"></recent-search>
    </carousel>
</template>

<script>
    import { SearchHistory } from '../../utils/pricetravel/shared/searchHistory';
    const path = location.pathname.toLowerCase();
    const type = SearchHistory.getLandingPagePath(path);
    export default {
        data() {
            return {
                history: SearchHistory.getRecentSearches(type),
                site: window.__pt.settings.site,
            };
        },
        methods: {
            formatDate(dateIn, dateOut, tripMode) {

                if (!tripMode) {
                    return `${dayjs(dateIn).format('D MMM')}`;
                }
                return `${dayjs(dateIn).format('D MMM')} - ${dayjs(dateOut).format(
                    'D MMM'
                )}`;
            },
        },
        computed: {
            titleId() {
                return `recent-search-title-${this._uid}`;
            },
            descId() {
                return `recent-search-desc-${this._uid}`;
            },
        },
    };
</script>
